import React from "react";
import { Ripple } from "primereact/ripple";

interface TabFilterProps {
    label: string;
    onTabChange: () => void;
    isActive: boolean;
    count?: number;
    tabClassName?: string;
    disabled?: boolean;
}

const TabFilter: React.FC<TabFilterProps> = (
    {
        label,
        onTabChange,
        isActive,
        count,
        tabClassName,
        disabled
    }
) => {
    return (
        <div className="contact_tab_item">
            <button
                type="button"
                className={`contact_tab_btn ${tabClassName ?? ''} ${isActive ? "active" : ""} p-ripple`}
                onClick={onTabChange}
                disabled={disabled}
            >
                {label}{count ? `: ${String(count).padStart(2, '0')}` : ''}
                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
            </button>
        </div>
    );
};

export default TabFilter;